import {isWithinInterval, sub, parse} from 'date-fns';

export const convertToEpoch = (YYMMDD: string): number => {
  try {
    let year = parseInt(YYMMDD.substring(0, 2), 10);
    year = year < 50 ? 2000 + year : 1900 + year;
    const month = parseInt(YYMMDD.substring(2, 4), 10) - 1;
    const day = parseInt(YYMMDD.substring(4, 6), 10);
    return Date.UTC(year, month, day) + 12 * 60 * 60 * 1000;
  } catch (e) {
    console.log('e', e);
    return 0;
  }
};
export const checkValidity = (YYMMDD: string): boolean => {
  try {
    const epoch = convertToEpoch(YYMMDD);
    if(epoch === 0) {
      return false;
    }
    const currentEpoch = new Date().getTime();
    if(epoch < currentEpoch) {
      return false;
    }
    return true;
  } catch (e) {
    return false;
  }
};

export const isDateWithinPeriod = (dateInput: string, period: string): boolean => {
  try {
    let inputDate: Date;
    if(typeof dateInput === 'string') {
      inputDate = parse(dateInput, 'dd/MM/yyyy', new Date());
    } else {
      inputDate = new Date(dateInput);
    }
    if(isNaN(inputDate.getTime())) {
      return false;
    }
    let periodDate: Date;
    switch(period) {
    case '1 year':
      periodDate = sub(new Date(), {years: 1});
      break;
    case '1 month':
      periodDate = sub(new Date(), {months: 1});
      break;
    case '1 week':
      periodDate = sub(new Date(), {weeks: 1});
      break;
    case '1 day':
      periodDate = sub(new Date(), {days: 1});
      break;
    default:
      return false;
    }
    return isWithinInterval(inputDate, {start: periodDate, end: new Date()});
  } catch (e) {
    return false;
  }
};

export const cleanDate = (dateString: string): Date => {
  const normalizedDateString = dateString.replace(' +0000', 'Z');
  const parsedDate = Date.parse(normalizedDateString);
  if(!isNaN(parsedDate)) {
    return new Date(parsedDate);
  } else {
    return null; 
  }
};
